import {EventEmitter, Injectable, Output} from '@angular/core';
import {ConfService} from './conf.service';
import {environment} from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApigatewayListenerService {

  @Output() apiGatewayListener: EventEmitter<any> = new EventEmitter();


  constructor() {
    this.apiGatewayListener.subscribe(
        (eventObject) => {
          return new Promise((resolve, reject) => {
            resolve('success');
            // This listener has to be removed
          });
        }
    );
  }}
